const SDK_VERSION = '7.52.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
